import { registerComponent } from '@gig/magic-common';
import PromotionCardComponent from './promotion-card.vue.js';

var PromotionCard = registerComponent(PromotionCardComponent);

export { PromotionCard };
